import { render, staticRenderFns } from "./SelectBtn.vue?vue&type=template&id=fc274040&scoped=true"
import script from "./SelectBtn.vue?vue&type=script&lang=js"
export * from "./SelectBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc274040",
  null
  
)

export default component.exports